import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "./motion";
import "./AlignBg.css";

/** Page banner shown at the top of inner pages. */
const AlignBg = ({ title, name, kicker }) => {
  return (
    <section className="page-header">
      <div className="page-header__grid" aria-hidden="true" />
      <motion.div
        className="page-header__inner container"
        variants={stagger}
        initial="hidden"
        animate="visible"
      >
        <motion.span className="page-header__kicker" variants={fadeUp}>
          {kicker || `// ${name.toLowerCase()}`}
        </motion.span>
        <motion.h1 className="page-header__title" variants={fadeUp}>
          {title}
        </motion.h1>
        <motion.nav
          className="page-header__crumbs"
          variants={fadeUp}
          aria-label="Breadcrumb"
        >
          <Link to="/">Home</Link>
          <span className="page-header__sep" aria-hidden="true">/</span>
          <span className="page-header__current">{name}</span>
        </motion.nav>
      </motion.div>
    </section>
  );
};

export default AlignBg;
